export default __webpack_public_path__ + "locales/vi/FillPDFDialog.json?hash=46768dcee2e43a66e3cb8f637a930734";